import React from "react"

export const TableBody = ({
    getTableBodyProps,
    rows,
    prepareRow,
    rowClassName,
    columns
}) => {

    const getColumnSize = React.useCallback((columnName) => {
        // sum should be 24
        switch (columnName) {
            case columns[0].accessor:
                return "c-table__cell--7"
            case columns[1].accessor:
                return "c-table__cell--3"
            case columns[2].accessor:
                return "c-table__cell--3"
            case columns[3].accessor:
                return "c-table__cell--3"
            case columns[4].accessor:
                return "c-table__cell--4"
            case columns[5].accessor:
                return "c-table__cell--2"
            case columns[6].accessor:
                return "c-table__cell--3"
            default:
                return "flex-initial"
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <tbody {...getTableBodyProps()}>
            {// Loop over the table rows
            rows.map(row => {
                // Prepare the row for display
                prepareRow(row)
                return (
                    // Apply the row props
                    <tr className={"c-table__row p-5 lg:p-0"} {...row.getRowProps()}>
                        {// Loop over the rows cells
                        row.cells.map(cell => {
                            // Apply the cell props
                            return (
                                <td className={`c-table__cell md:p-5 ${rowClassName} ${getColumnSize(cell?.column?.id)}`} {...cell.getCellProps()}>
                                    <span className={"text-xs"}>{cell.render("Cell")}</span>
                                </td>
                            )
                        })}
                    </tr>
                )
            })}
        </tbody>
    )
}
